import React, { forwardRef } from "react";

export const UploadImage = forwardRef((props, ref) => (
    <input
        name="uploadImage"
        type="file"
        accept="image/*"
        onChange={props.handleUpload}
        ref={ref}
        style={{ display: 'none' }} />
))
